function CleanUpUrl (url) {
  if (url) {
    if (url.slice(-1) === "&" || url.slice(-1) === "?") {
      return url.substring(0, url.length-1)
    }
  }
  return url
}

export default CleanUpUrl;